module.exports = __webpack_public_path__ + "static/media/15.97ea8c80.jpg";